import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const RHYMES_WITH_ACTIVITY_FRAGMENT = gql `
  fragment RhymesWithActivityFragment on RhymesWithActivity {
    rounds {
      steps {
        answer
        answerAudio {
          audio {
            ...AssetFragment
          }
        }
        activityImage: optionalImage {
          image {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default RHYMES_WITH_ACTIVITY_FRAGMENT;
